import { useSymbolsStore } from "../store/Symbols.js";
import { useSymbolsRender } from "../utils/useRender.js";
export var BracketsLeft = props => {
  var {
    BracketsLeft: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'BracketsLeft');
  return null;
};
BracketsLeft.displayName = 'JVR.BracketsLeft';